import axios from "axios";
import * as Sentry from "@sentry/nextjs";
import { forceClientLogout } from "@/lib/auth/forceClientLogout";

function captureApiError(error) {
  const isNetworkOrCors =
    !error.response &&
    (error.code === "ERR_NETWORK" ||
      error.message === "Network Error" ||
      error.message?.includes("Failed to fetch"));

  if (!isNetworkOrCors && error.response?.status < 500) {
    return;
  }

  Sentry.captureException(error, {
    tags: {
      type: isNetworkOrCors ? "network_or_cors" : "api_error",
    },
    extra: {
      url: error.config?.url,
      method: error.config?.method,
      baseURL: error.config?.baseURL,
      status: error.response?.status,
      code: error.code,
    },
  });
}

/** Same-origin BFF — attaches Bearer from httpOnly cookies and refreshes server-side. */
export const clientApi = axios.create({
  baseURL: "/api/proxy",
  withCredentials: true,
});

clientApi.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    config.headers = {
      ...config.headers,
      "X-Origin-Domain": window.location.host,
    };
  }

  return config;
});

function isPublicAuthRequest(error) {
  const url = String(error?.config?.url || "");
  return (
    url.includes("/c/auth/otp") ||
    url.includes("/c/auth/verify") ||
    url.includes("/public/auth")
  );
}

clientApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    captureApiError(error);

    if (error.response?.status === 401 && !isPublicAuthRequest(error)) {
      // BFF already cleared cookies on session death; sync client and navigate once.
      forceClientLogout();
    }
    throw error;
  },
);
